<template>
  <section>
    <modal :title="title" :show="showModal" @close="closeModal()">
      <div class="lists-content" slot="content">
        <div class="lists-intro">
          <div><span class="eyebrow">Segmentação</span><h3>Organize seus contatos</h3><p>Use listas para agrupar sua base por interesse, origem ou objetivo.</p></div>
          <button type="button" class="button primary" @click="openModalNew()"><i class="fas fa-plus"></i> Nova lista</button>
        </div>
        <ul v-if="lists.length" class="lists-grid">
          <li v-for="m in lists" :key="m.id" class="list-item">
            <div class="list-icon"><i class="fas fa-list-ul"></i></div>
            <div class="list-name">{{ m.name }}</div>
            <div class="list-actions">
              <button type="button" title="Editar lista" @click="openModalEdit(m)"><i class="far fa-edit"></i></button>
              <button type="button" class="danger" title="Excluir lista" @click="openModalDelete(m.id)"><i class="far fa-trash-alt"></i></button>
              </div>
          </li>
        </ul>
        <div v-else class="lists-empty"><div><i class="fas fa-list-ul"></i></div><h4>Nenhuma lista criada</h4><p>Crie sua primeira lista para organizar os contatos.</p><button type="button" class="button primary" @click="openModalNew()">Criar lista</button></div>
      </div>
      <div class="action" slot="action">
        <div class="flex center">
          <a @click="closeModal()" class="button secondary medium">
            Fechar
          </a>
        </div>
      </div>
    </modal>
    <!-- new list -->
    <new-list
      :show="showEditModal"
      description="Você tem certeza que deseja deletar essa lista?"
      :list="newList"
      @close="
        showEditModal = false;
        newList = null;
      "
      @accept="newOrEditList($event)"
    ></new-list>
    <!-- modal confirm delete -->
    <modal-confirm
      :show="showDeleteModal"
      description="Você tem certeza que deseja deletar essa lista?"
      @cancel="
        showDeleteModal = false;
        selectModalDelete = null;
      "
      @accept="removeList(selectModalDelete)"
    ></modal-confirm>
  </section>
</template>

<script>
import { getLists, createList, updateList, removeList } from "@/services/list";

import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";
import NewList from "./NewList";

const auxNewList = {
  name: ''
}

export default {
  name: "modal-lists",
  props: {
    titleName: {
      required: false,
      default: "Listas",
    },
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "false",
    },
    tag: {
      required: true,
      default: Object,
    },
  },
  components: {
    Modal,
    ModalConfirm,
    NewList,
  },
  data() {
    return {
      showDeleteModal: false,
      selectModalDelete: null,
      newList: null,
      showEditModal: false,
      showModal: false,
      seenGuide: {},
      title: "Listas",
      lists: [],
      typeList: [
        { id: "TEXT", label: "TEXT" },
        { id: "AWAIT", label: "AWAIT" },
        { id: "IMG", label: "IMG" },
        { id: "LINK", label: "LINK" },
      ],
      timeList: [
        { id: "10MIN", label: "10MIN" },
        { id: "30MIN", label: "30MIN" },
        { id: "60MIN", label: "60MIN" },
        { id: "24H", label: "24H" },
        { id: "48H", label: "48H" },
        { id: "72H", label: "72H" },
      ],
    };
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
  },
  mounted() {
    this.getLists();
  },
  computed: {
    isEdit() {
      return this.tag && this.tag.id;
    },
  },
  methods: {
    newOrEditList(auxList) {
      this.showEditModal = false
      this.newList = null

      if (auxList.id) {
        return this.updateList(auxList)
      } 

      return this.createList(auxList)
    },
    openModalEdit(listAux) {
      this.showEditModal = true
      this.newList = listAux
    },
    openModalNew() {
      this.showEditModal = true
      this.newList = Object.assign({}, auxNewList)
    },
    openModalDelete(listId) {
      this.showDeleteModal = true
      this.selectModalDelete = listId
    },
    getLists() {
      getLists()
        .then((result) => {
          this.lists = result;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "falha ao buscar listas",
          });
        });
    },
    createList(list) {
      createList(list)
        .then((result) => {
          this.lists.push(result);
          this.$toast.success({
            title: "Sucesso",
            message: "Lista criada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao criar lista",
          });
        });
    },
    updateList(list) {
      updateList(list.id, list)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Lista editada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao editar lista",
          });
        });
    },
    removeList(list_id) {
      removeList(list_id)
        .then(() => {

          this.lists = this.lists.filter(l => l.id != list_id)
          this.$toast.success({
            title: "Sucesso",
            message: "Lista removida com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao remover lista",
          });
        })
        .finally(() => {
          this.showDeleteModal = false
          this.selectModalDelete = null
        })
    },
    acceptModal() {
      this.showModal = false;
      this.$emit("accept", this.tag);
    },
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.lists-intro { padding-bottom: 20px; display: flex; align-items: flex-end; justify-content: space-between; gap: 20px; border-bottom: 1px solid #eaecf0; }
.eyebrow { color: #7c3aed; font-size: 1rem; font-weight: 750; letter-spacing: .09em; text-transform: uppercase; }
.lists-intro h3 { margin: 5px 0; color: #171923; font-size: 1.8rem; }
.lists-intro p { color: #667085; font-size: 1.2rem; }
.lists-intro .button { display: inline-flex; align-items: center; gap: 7px; }
.lists-grid { max-height: 380px; margin-top: 12px; padding: 0 4px 0 0; overflow-y: auto; list-style: none; }
.list-item { margin-top: 7px; padding: 12px; display: flex; align-items: center; border: 1px solid #eaecf0; border-radius: 11px; background: #fff; transition: border-color .18s ease, background .18s ease; }
.list-item:hover { border-color: #d7cce9; background: #fcfaff; }
.list-icon { width: 36px; height: 36px; margin-right: 11px; display: flex; align-items: center; justify-content: center; border-radius: 9px; color: #7c3aed; background: #f2ecff; }
.list-name { min-width: 0; flex: 1; overflow: hidden; color: #344054; font-weight: 650; text-overflow: ellipsis; white-space: nowrap; }
.list-actions { display: flex; gap: 5px; }
.list-actions button { width: 34px; height: 34px; border: 1px solid #e4e7ec; border-radius: 8px; color: #667085; background: #fff; cursor: pointer; }
.list-actions button:hover { border-color: #cfc4e4; color: #6d28d9; }
.list-actions button.danger:hover { border-color: #fecdca; color: #b42318; background: #fef3f2; }
.lists-empty { padding: 48px 20px 24px; text-align: center; }
.lists-empty > div { width: 56px; height: 56px; margin: 0 auto 14px; display: flex; align-items: center; justify-content: center; border-radius: 17px; color: #7c3aed; background: #f2ecff; font-size: 1.8rem; }
.lists-empty h4 { color: #171923; font-size: 1.5rem; }
.lists-empty p { margin: 6px 0 18px; color: #667085; }
.action { margin-top: 24px; }
@media screen and (max-width: 600px) { .lists-intro { align-items: stretch; flex-direction: column; } .lists-intro .button { justify-content: center; } }
</style>
